var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 58,
    viewBox: "0 0 62 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0417 0H0V58H61.0417V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_562)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0417 0H0V58H61.0417V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 12H17C14.2386 12 12 14.2386 12 17V41C12 43.7614 14.2386 46 17 46H44C46.7614 46 49 43.7614 49 41V17C49 14.2386 46.7614 12 44 12Z",
    fill: "#353535",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.25H44C46.6234 12.25 48.75 14.3766 48.75 17V41C48.75 43.6234 46.6234 45.75 44 45.75H17C14.3766 45.75 12.25 43.6234 12.25 41V17C12.25 14.3766 14.3766 12.25 17 12.25Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1465 20.9734V39.0161",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0977 18.5032V41.4666",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8457 17.6929V42.2966",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5131V41.4764",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0938 22.6137V37.3761",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4766 20.1534V39.8364",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8535 24.6547V36.1365",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1133 22.6137V37.3761",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7656 24.254V35.7357",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7773 20.1533V39.8364",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5762 16.0429V43.9272",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8281 20.1386V39.8217",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2109 24.254V35.7357",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5234 25.8795V34.0805",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_28_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 7V52",
    stroke: "#AA6BFD",
    strokeWidth: 2,
    strokeMiterlimit: 8,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_28_562",
    x: 14.0398,
    y: 1.7,
    width: 10.6,
    height: 55.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.419608 0 0 0 0 0.992157 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_562"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_28_562",
    result: "effect2_dropShadow_28_562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_28_562",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.d261a7f9655b92f1e48f91733db3b6fd.svg";
export { ForwardRef as ReactComponent };